import { DatePicker, type DatePickerProps } from "antd";
import type { ReactNode } from "react";
import { FormItem, type FormItemProps } from "~components/Form/FormItem";

type Props<TForm> = FormItemProps<TForm> & {
  label?: ReactNode;
  /** `disabled` moved out of `datePickerProps` for convenience as it used frequently */
  disabled?: boolean;
  /** Antd `DatePickerProps` */
  datePickerProps?: Omit<DatePickerProps, "disabled">;
};

export const FormDatePicker = <TForm = unknown>({ label, disabled, datePickerProps, ...rest }: Props<TForm>) => {
  const content = (
    <FormItem<TForm> layout="vertical" className="form-date-item" label={label} {...rest}>
      <DatePicker disabled={disabled} {...datePickerProps} />
    </FormItem>
  );

  return rest.hidden ? content : <div>{content}</div>;
};
